import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PackingCode } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { PackingCodeService } from '../../services/packing-code.service';

@Component({
  selector: 'app-packing-code-dropdown',
  templateUrl: './packing-code-dropdown.component.html',
  providers: [PackingCodeService],
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class PackingCodeDropdownComponent extends GenericBaseModelDropDown<PackingCode> {

  constructor(private service: PackingCodeService) {
    super(service, "PackingCode");
  }

}
